import { render, staticRenderFns } from "./xuexiDetail.vue?vue&type=template&id=71b8b3ae&scoped=true"
import script from "./xuexiDetail.vue?vue&type=script&lang=ts"
export * from "./xuexiDetail.vue?vue&type=script&lang=ts"
import style0 from "./xuexiDetail.vue?vue&type=style&index=0&id=71b8b3ae&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8b3ae",
  null
  
)

export default component.exports